module.exports = __webpack_public_path__ + "static/img02_02-88fe89c0e1dc0e475c66e925de569e5e.png";